export const messages = {
  title: {
    id: 'admin/promotions.form.budget.title',
  },
  description: {
    id: 'admin/promotions.form.budget.view.unlimited',
  },
  add: {
    id: 'admin/promotions.form.budget.view.add',
  },
  edit: {
    id: 'admin/promotions.utils.edit',
  },
  delete: {
    id: 'admin/promotions.utils.remove',
  },
  totalSpent: {
    id: 'admin/promotions.form.budget.view.total-spent',
  },
  tooltip: {
    id: 'admin/promotions.form.budget.view.tooltip',
  },
  notificationTooltip: {
    id: 'admin/promotions.form.budget.view.notification.tooltip',
  },
  stopAlert: {
    id: 'admin/promotions.form.budget.view.alert',
  },
  disabled: {
    api: {
      id: 'admin/promotions.form.budget.view.alert.disabled',
    },
    discountType: {
      id: 'admin/promotions.form.budget.view.alert.discount-type',
    },
    addTooltip: {
      id: 'admin/promotions.form.budget.view.add.discount-type.tooltip',
    },
  },
  deleteModal: {
    title: {
      id: 'admin/promotions.form.budget.modal.delete.title',
    },
    subtitle: {
      id: 'admin/promotions.form.budget.modal.delete.subtitle',
    },
    description: {
      id: 'admin/promotions.form.budget.modal.delete.description',
    },
    cancel: {
      id: 'admin/promotions.utils.cancel',
    },
    continue: {
      id: 'admin/promotions.utils.continue',
    },
  },
  unauthorized: {
    id: 'admin/promotions.form.budget.view.unauthorized.description',
  },
  unauthorizedWrite: {
    id: 'admin/promotions.form.budget.write.unauthorized.tooltip',
  },
}
